import { DocumentItem, SubEntityType } from '../../models';
import { knowledgeBaseHttp } from '../knowledge-base-api';

export const getSoftware = async (groupId: number, locale: string): Promise<DocumentItem[]> => {
  try {
    const url = `/group/${groupId}/${SubEntityType.Software}?marketLocale=${encodeURIComponent(locale)}`;
    const response = await knowledgeBaseHttp.get<DocumentItem[]>(url);

    return response?.data ?? [];
  } catch (error) {
    console.error(`Error fetching Software:`, error);
    return [];
  }
};
